<div
  (action)="redirect($event)"
  [error]="content.medallionBanner.error || content.menu.error"
  auraSkeletonLoader
>
  <div class="skymiles__wrapper">
    <div class="skymiles__wrapper__medallion">
      <div class="skymiles__wrapper__medallion__container">
        <aura-medallion-banner
          (redirect)="redirect($event, '_blank')"
          *ngIf="!content.medallionBanner.disabled"
          [content]="content.medallionBanner"
        ></aura-medallion-banner>
      </div>
    </div>
    <idp-notification
      *ngIf="notification"
      [content]="notification"
      [target]="'skymiles__wrapper__medallion'"
    ></idp-notification>
    <div class="skymiles__wrapper__banner"></div>
    <div class="skymiles__wrapper__top">
      <div class="skymiles__wrapper__top--background-image"></div>
      <div class="skymiles__wrapper__top__container">
        <div class="skymiles__wrapper__top__container--left">
          <idp-menu
            *ngIf="!content.menu.disabled"
            [content]="content.menu"
          ></idp-menu>
        </div>
        <div class="skymiles__wrapper__top__container--content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
